import { useLayoutEffect, useRef } from "react";

import type { PropertyForestSnapshot } from "@/contexts/PropertyForestSnapshotContextState";
import {
  clearPropertyForestSnapshot,
  publishPropertyForestSnapshot,
} from "@/shared/config/propertyForestSnapshotStore";

/** Owns route map data without introducing a provider into the visual tree. */
export function usePublishPropertyForestSnapshot(
  propertyId: string | null,
  snapshot: PropertyForestSnapshot,
): void {
  const owner = useRef(Symbol("property-forest-snapshot-owner")).current;

  useLayoutEffect(() => {
    if (!propertyId) return;
    publishPropertyForestSnapshot(propertyId, owner, snapshot);
  }, [owner, propertyId, snapshot]);

  useLayoutEffect(
    () => () => {
      if (propertyId) clearPropertyForestSnapshot(propertyId, owner);
    },
    [owner, propertyId],
  );
}
